<template>
  <VField
    v-slot="{ handleChange, field, errorMessage }"
    :name="name"
    v-bind="$attrs"
  >
    <slot
      name="label"
      :error="!!errorMessage"
    />
    <div>
      <slot
        name="field"
        :field="field"
        :handle-change="handleChange"
        :error="!!errorMessage"
      />
      <LpFieldError
        v-if="showError"
        :message="errorMessage"
      />
    </div>
  </VField>
</template>

<script>
import { Field } from 'vee-validate';

export default {
  components: {
    VField: Field,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    showError: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
